import { AdminFeature } from '@website/components/admin/AdminFeature';
import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';
import { Table } from 'react-bootstrap';
import InvoiceRowItem from './InvoiceRowItem';

export default function AdminInvoiceSection({
  booking,
}: {
  booking: Pick<
    UserBookingDetailsQuery['booking'],
    'created' | 'commissionDetails' | 'invoiceSummary' | 'spaces' | 'group'
  >;
}) {
  const { commissionDetails } = booking;
  const { commissionPercentage } = booking.group;

  const commissionLessCredit = commissionDetails.commissionLessCredits.amountZD;

  // 0.2 to 20%
  const percent = (parseFloat(commissionPercentage) * 100).toFixed(2);

  return (
    <AdminFeature>
      <Table className="w-100" borderless size="sm">
        <tbody>
          <InvoiceRowItem
            amountZD={commissionDetails.netCommission.amountZD}
            currency={commissionDetails.netCommission.currency}
            lineText={`Net Commission`}
            className="fw-normal"
            amountClassName=""
            roundAmountOff
          />

          <InvoiceRowItem
            amountZD={commissionDetails.commission.amountZD}
            roundAmountOff
            currency={commissionDetails.commission.currency}
            lineText={`Commission (${percent}%)`}
            isIndented
            className="text-muted small"
            amountClassName="text-muted small"
          />

          {commissionDetails.commissionLessCredits.amountZD !== 0 && (
            <InvoiceRowItem
              amountZD={commissionLessCredit}
              roundAmountOff
              currency={commissionDetails.commissionLessCredits.currency}
              lineText={`Less credits`}
              isIndented
              className="text-muted small"
              amountClassName="text-muted small"
            />
          )}

          {commissionDetails.numberOfSpacesCancelled > 0 && (
            <InvoiceRowItem
              amountZD={commissionDetails.totalAmountCancelled.amountZD}
              roundAmountOff
              currency={commissionDetails.totalAmountCancelled.currency}
              lineText={`${commissionDetails.numberOfSpacesCancelled > 1 ? `${commissionDetails.numberOfSpacesCancelled} spaces` : '1 space'} cancelled`}
              isIndented
              className="text-muted small"
              amountClassName="text-muted small"
            />
          )}

          <InvoiceRowItem
            amountZD={commissionDetails.cashReceived.amountZD}
            roundAmountOff
            currency={commissionDetails.cashReceived.currency}
            lineText="Cash Received"
            className="fw-normal"
            amountClassName=""
          />

          {commissionDetails.expectedCashReceived.amountZD !== 0 && (
            <InvoiceRowItem
              amountZD={commissionDetails.expectedCashReceived.amountZD}
              roundAmountOff
              currency={commissionDetails.expectedCashReceived.currency}
              lineText="Cash Received"
              isIndented
              className="text-muted small"
              amountClassName="text-muted small"
            />
          )}

          {commissionDetails.commissionRefundAmount.amountZD !== 0 && (
            <InvoiceRowItem
              amountZD={commissionDetails.commissionRefundAmount.amountZD}
              roundAmountOff
              currency={commissionDetails.commissionRefundAmount.currency}
              lineText="Refund"
              isIndented
              className="text-muted small"
              amountClassName="text-muted small"
            />
          )}
        </tbody>
      </Table>
    </AdminFeature>
  );
}
